import { store } from 'store/store';
import { pluginHandleAttachFailed } from 'features/streaming/actions';
import { GENERIC_JANUS_ERROR } from 'utils/webrtc/errors';

export const handleAttachError = (source: string) => (error: unknown, response?: Response) => {
  store.dispatch(pluginHandleAttachFailed(source));

  GENERIC_JANUS_ERROR(source)(error, response);
};
